/* eslint-disable no-unused-expressions */
import React from 'react';
import Wrp from '../Wrp/Wrp';
import {isSet} from '../../Utils/CommonFunctions';


export const FieldBlock = (props) =>{
      const className = [];
      (props.className)?className.push(props.className):className.push('form-group');
      if(props.isPopupWindow===false){
        className.push('row');
      }
      const styles={
        style:{...props.styles}
      }
    return (
        <Wrp>
          <div {...styles} key={props.item.id} className={(props.colType==='single' || props.type==='subform')? "col-12":"col-6"}>
              <div className={className.join(' ')} {...styles}>
                      {props.children}
              </div> 
          </div>
        </Wrp>
    )
}

export const InputBlock = (props) =>{
  const className = [];
  (props.inputBlockClass)?className.push(props.inputBlockClass):className.push('');
  if(props.isPopupWindow===false){
    className.push('col-lg-9 col-md-9 col-sm-8');
  }
 if(isSet(props.validation,{hasErrorClass:''}).hasErrorClass!==''){
  className.push(props.validation.hasErrorClass)
 }
 //?className.push(props.validation.hasErrorClass):'';
  
  return (
    <Wrp>
    <div className={className.join(' ')}>
            {props.children}
    </div> 
</Wrp>
  )
}


  //VALIDATION MESSAGE DISPLAY BLOCK
  export const ErrorBlock = (props) =>{
    return (
     <div>
          {props.message!=='' ? <span className="text-danger m-1">{props.message}</span> : ''}
     </div>
  )
 }  


